import React from 'react';

import { Box, H3, Link, Separator, Text } from '@betterment/samba-react';

const TermsAndConditions: React.FC = () => {
  return (
    <Box
      css={{
        border: 'solid 1px',
        borderColor: 'border',
        borderRadius: 'medium',
        padding: 'space.200',
      }}
    >
      <H3 variant="title100">Term and conditions</H3>
      <Separator css={{ my: 'space.150' }} />
      <Text
        as="p"
        css={{
          marginBottom: 'space.150',
        }}
      >
        Betterment&apos;s{' '}
        <Link href="https://www.betterment.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">
          privacy policy
        </Link>{' '}
        and{' '}
        <Link href="https://www.betterment.com/customeragreement" target="_blank" rel="noopener noreferrer">
          customer agreements
        </Link>
        , which include the Brokerage Agreement, Advisory Agreement, consent to electronic delivery of documents and
        written communications, and other important agreements. You also acknowledge that you have received a copy of
        our{' '}
        <Link href="https://www.betterment.com/adv" target="_blank" rel="noopener noreferrer">
          Form ADV brochure
        </Link>
        . Your advisory agreement contains a predispute arbitration clause highlighted in paragraph 34 on page 33. Your
        brokerage agreement contains a predispute arbitration clause highlighted in paragraph 36 on page 71.
      </Text>
    </Box>
  );
};

export default TermsAndConditions;
